var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.948,
    height: 13.716,
    viewBox: "0 0 10.948 13.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-parking",
    "data-name": "Icon map-parking",
    d: "M11.244,0H5.04V13.716H8.057V9.327h3.187c3.419,0,4.744-2.708,4.744-4.943S14.663,0,11.244,0Zm-.827,6.583H8.057V2.469h2.36c1.4,0,2.652.309,2.652,2.054S11.82,6.583,10.418,6.583Z",
    transform: "translate(-5.04)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/parking.ae42da2393b083319bf65c345062382d.svg";
export { ForwardRef as ReactComponent };